import {Component, computed, inject, Input, input} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {CuttingPlan} from "../../service/models/cutting-plan.model";
import {DecimalPipe} from "@angular/common";
import {ColorConverter, ColorInfo} from "../../../../../core/util/color-converter";



export interface Consumption {
  productCode: string;
  color: ColorInfo;
  material: string;
  brutto: number; // brutto menekki (mm) = profiilien lukumäärä * CuttingPlan.profileLength
  netto: number;  // netto menekki (mm) = summa profiilien usedLength
  waste: number;  // hukkamäärä (mm) = brutto - netto
}

@Component({
  selector: 'app-quantity-collective-group',
  standalone: true,
  imports: [
    TranslatePipe,
    DecimalPipe
  ],
  templateUrl: './quantity-collective-group.component.html',
  styleUrl: './quantity-collective-group.component.scss',
})
export class QuantityCollectiveGroupComponent {


  accessories = input<any>();
  lamellaCuttingPlan = input<CuttingPlan>();
  mountingProfileCuttingPlan = input<CuttingPlan>();
  frameProfileCuttingPlan = input<CuttingPlan>();



  calculateScrewPackages(screws: number){
    const PACKAGESIZE = 500;
    return Math.ceil(screws / PACKAGESIZE);
  }

  protected calculateConsumption(plan: CuttingPlan): Consumption[] {

    // Käytetään ryhmittelyyn avainta, joka muodostetaan tuotetiedoista
    const consumptionMap: { [key: string]: Consumption } = {};

    // Käydään läpi kaikki profiilit
    plan.profiles.forEach((profile) => {
      // Luo ryhmittelyavain esimerkiksi muodossa "23059_#3F888F_Powder Coated"
      const key = `${profile.productCode}_${profile.color}_${profile.material}`;

      // Jos tätä ryhmää ei vielä ole, alustetaan se
      if (!consumptionMap[key]) {
        consumptionMap[key] = {
          productCode: profile.productCode,
          color: ColorConverter.convert(profile.color),
          material: profile.material,
          brutto: 0,
          netto: 0,
          waste: 0,
        };
      }

      // Päivitetään ryhmän arvoja:
      // brutto lisätään kertomalla profiilipituus (CuttingPlan.profileLength) yhdellä profiililla
      consumptionMap[key].brutto += plan.profileLength;
      // netto on käytetty pituus (usedLength) profiilissa
      consumptionMap[key].netto += profile.usedLength;
    });

    // Lasketaan hukkamäärä jokaiselle ryhmälle
    Object.keys(consumptionMap).forEach((key) => {
      const group = consumptionMap[key];
      group.waste = group.brutto - group.netto;
    });

    // Muutetaan map taulukoksi ja palautetaan
    return Object.values(consumptionMap);
  }

}
